import { gql } from 'apollo-angular';

export const statisticsUser = gql`
	fragment User on UserOutput {
		id
		computedRemark
		regularityLevel
	}
`;
